<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarTabItemProps {
  label?: string;
  value?: string;
  leadingIconTemplate?: IconConstant | '';
  trailingIconTemplate?: IconConstant | '';
  selected?: boolean;
  disabled?: boolean;
}

interface GrammarCardSlots {
  badge?: Slot;

}

const props = withDefaults(defineProps<GrammarTabItemProps>(), {
  label: '',
  value: '',
  leadingIconTemplate: '',
  trailingIconTemplate: '',
  selected: false,
  disabled: false,
});

const slots = defineSlots<GrammarCardSlots>();
</script>

<template>
  <tpg-tab-item v-bind="props" style="--navigationTabItemSizingMainHeight: 2.75rem">
    <div
      v-if="slots.badge"
      slot="badge"
    >
      <slot name="badge" />
    </div>
  </tpg-tab-item>
</template>
